import { UpgradeStep1 } from './UpgradeStep1';
import UpgradeStripeElements from './UpgradeStripeElements';
import { UpgradeStep3 } from './UpgradeStep3';

export const UpgradeSteps = [UpgradeStep1, UpgradeStripeElements, UpgradeStep3];
